import { useState } from "react";
import { toast } from "sonner";
import { Hammer } from "lucide-react";
import { http, errMsg } from "../../lib/api";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogTrigger } from "../ui/dialog";
import { Input } from "../ui/input";

export const OPTS = {
  collection: [["researched", "Researched layout"], ["founders", "Founder's layout"]],
  edition: [["luxury", "Luxury"], ["solo", "Solo"], ["wine", "Wine"], ["escape", "Escape"], ["adventure", "Adventure"]],
  tier: [["mini-break", "Mini-Break"], ["premium", "Premium"], ["ultra", "Ultra"], ["elite", "Elite"]],
};

export const Pills = ({ name, value, onPick }) => (
  <div className="flex flex-wrap gap-2">
    {OPTS[name].map(([k, l]) => (
      <button type="button" key={k} data-testid={`build-${name}-${k}`} onClick={() => onPick(k)}
        className={`rounded-full border px-3 py-1.5 text-sm transition-colors ${value === k ? "border-[#C9A847] bg-[#C9A847]/15 text-stone-900" : "border-stone-200 text-stone-600 hover:border-stone-400"}`}>{l}</button>
    ))}
  </div>
);

export const BuildDialog = ({ req, onBuilt }) => {
  const [open, setOpen] = useState(false);
  const [f, setF] = useState({ collection: "researched", edition: "luxury", tier: "premium", price: req?.quote ?? "" });
  const [busy, setBusy] = useState(false);
  const set = (k) => (v) => setF((s) => ({ ...s, [k]: v }));
  const build = async () => {
    setBusy(true);
    try {
      await http.post(`/bespoke/requests/${req.id}/build`, { ...f, price: Number(f.price) });
      toast.success("Bespoke kit is being researched");
      setOpen(false); onBuilt();
    } catch (e) { toast.error(errMsg(e)); } finally { setBusy(false); }
  };
  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogTrigger asChild>
        <button data-testid="build-kit-open" className="inline-flex items-center gap-2 rounded-sm bg-[#C9A847] text-white px-4 py-2 text-sm font-bold hover:bg-[#B8973A]"><Hammer size={15} /> Build kit</button>
      </DialogTrigger>
      <DialogContent data-testid="build-kit-dialog" className="bg-white text-[#2B2A26] max-w-lg">
        <DialogHeader><DialogTitle>Build a bespoke kit for {req.name}</DialogTitle></DialogHeader>
        <div className="space-y-4">
          {["collection", "edition", "tier"].map((k) => (
            <div key={k}><div className="text-xs uppercase tracking-[0.14em] text-stone-500 mb-1.5">{{ collection: "Layout", edition: "Edition", tier: "Depth (venue counts)"}[k]}</div><Pills name={k} value={f[k]} onPick={set(k)} /></div>
          ))}
          <div><div className="text-xs uppercase tracking-[0.14em] text-stone-500 mb-1.5">Price for this customer (AUD)</div>
            <Input data-testid="build-price" type="number" min={1} value={f.price} onChange={(e) => set("price")(e.target.value)} className="h-11 w-48" /></div>
          <button data-testid="build-kit-submit" disabled={busy || !f.price} onClick={build} className="w-full rounded-sm bg-[#2B2A26] text-white py-3 font-bold disabled:opacity-50">{busy ? "Starting…" : "Start research"}</button>
        </div>
      </DialogContent>
    </Dialog>
  );
};
